import { ReactElement, useMemo } from 'react';
import { Trans } from 'react-i18next';

import { Translate } from '@dreryk/react-common';
import { ModalCancelButton, ModalCloseButton, StrongText } from '@dreryk/react-components';

import { boundServiceTranslationKeys } from '../../../translations';

type HealthcareProviderPatientPortalBoundServiceCreateModalExitButtonsProps = {
   readonly onClose: VoidFunction;
   readonly shouldConfirmExit: boolean;
};

const ExitConfirmationSuffix = (): ReactElement => (
   <StrongText testId={'exitConfirm'}>
      <Translate>{boundServiceTranslationKeys.unsavedDataWillBeLost}</Translate>
   </StrongText>
);

export const HealthcareProviderPatientPortalBoundServiceCreateModalExitButtons = (
   props: HealthcareProviderPatientPortalBoundServiceCreateModalExitButtonsProps
): ReactElement => {
   const exitButtonConfig = useMemo(
      () => ({
         enabled: props.shouldConfirmExit,
         confirmationButtonLabel: boundServiceTranslationKeys.leave,
         content: (
            <Trans
               i18nKey={boundServiceTranslationKeys.leavingFormConfirmation}
               components={{
                  suffix: <ExitConfirmationSuffix />,
               }}
            />
         ),
      }),
      [props.shouldConfirmExit]
   );
   return (
      <>
         <ModalCancelButton onClick={props.onClose} shouldConfirmExit={exitButtonConfig} />
         <ModalCloseButton onClick={props.onClose} shouldConfirmExit={exitButtonConfig} />
      </>
   );
};
